import * as React from 'react';

import { useDesignSystemFlags } from '../../../Hooks';
import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';

function SvgInfoFillIconV1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm-1-8h2V7h-2v2z"
        fill="currentColor"
      />
    </svg>
  );
}

function SvgInfoFillIconV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-8.75 3V7h1.5v4h-1.5zM8 4.5A.75.75 0 118 6a.75.75 0 010-1.5z"
        fill="currentColor"
      />
    </svg>
  );
}

function InfoFillIcon(props: IconProps) {
  const { USE_NEW_ICONS } = useDesignSystemFlags();
  const component = USE_NEW_ICONS ? SvgInfoFillIconV2 : SvgInfoFillIconV1;
  return <Icon {...props} component={component} />;
}

export default InfoFillIcon;
